import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=202e4197"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports